
import TableList from '@/components/TableList/index.vue';

export default {
  props: ['creative_type', 'list'],
  components: {
    TableList: TableList
  },
  computed: {
    columnConfig: function columnConfig() {
      if (this.creativeType === 'video' || this.creativeType === 'graphic') {
        return [{
          label: '审核ID',
          prop: 'id'
        }, {
          label: '素材ID',
          prop: 'creative_id'
        }, {
          label: '素材名称',
          prop: 'creative_name'
        }, {
          label: 'UUID',
          prop: 'offer_uuid'
        }, {
          label: '平台',
          prop: 'platform'
        }, {
          label: '广告主',
          prop: 'adv_name'
        }, {
          label: '包名',
          prop: 'package_name'
        }];
      }
      return [{
        label: '审核ID',
        prop: 'id'
      }, {
        label: '素材ID',
        prop: 'creative_id'
      }, {
        label: '素材名称',
        prop: 'creative_name'
      }, {
        label: 'UUID',
        prop: 'offer_uuid'
      }, {
        label: '包名',
        prop: 'package_name'
      }];
    }
  }
};